/**
 * Dashboard › Products (PRIVATE fork) — list + detail over letpot-api
 * /admin/product via @greenhouse/crud.
 */

import { useMemo } from 'react';
import { defineCrud, CrudPage } from '@greenhouse/crud';
import { Package } from '../../../lib/icons';
import { letpotDataSource } from '../../../lib/dashboard/data-source';

interface ProductRow {
  _id: string;
  title: string;
  subtitle: string;
  device_type: string;
  category: string;
  online_count: number;
  device_count: number;
  visible: boolean;
  hot: boolean;
  firmware_version: string;
}

const dataSource = letpotDataSource<ProductRow>('product');

export function DashboardProducts() {
  const schema = useMemo(
    () =>
      defineCrud<ProductRow>({
        name: 'Product',
        icon: Package,
        idField: '_id',
        dataSource,
        columns: [
          { key: 'title', label: 'Title', sortable: true },
          { key: 'device_type', label: 'Device type', type: 'badge', width: '9rem', badgeMap: {} },
          { key: 'category', label: 'Category', responsiveHide: 'md' },
          {
            key: 'device_count',
            label: 'Devices',
            type: 'number',
            align: 'right',
            sortable: true,
            responsiveHide: 'lg',
          },
          { key: 'visible', label: 'Visible', type: 'boolean', align: 'center', responsiveHide: 'md' },
          { key: 'firmware_version', label: 'Firmware', responsiveHide: 'lg' },
          { key: 'subtitle', label: 'Subtitle', hidden: true },
          { key: 'online_count', label: 'Online', type: 'number', hidden: true },
          { key: 'hot', label: 'Hot', type: 'boolean', hidden: true },
        ],
        filters: [
          { key: 'title', label: 'Search', kind: 'text' },
          { key: 'device_type', label: 'Device type', kind: 'text', secondary: true },
          { key: 'visible', label: 'Visible', kind: 'boolean', secondary: true },
        ],
        detailTabs: [{ key: 'summary', label: 'Summary', kind: 'fields' }],
        access: { canView: true, canEdit: true },
        formFields: [
          { key: 'title', label: 'Title', type: 'text', required: true, width: 2 },
          { key: 'subtitle', label: 'Subtitle', type: 'text', width: 2 },
          { key: 'category', label: 'Category', type: 'text', width: 2 },
          { key: 'firmware_version', label: 'Latest firmware', type: 'text', width: 2 },
          { key: 'visible', label: 'Visible', type: 'switch', width: 2 },
          { key: 'hot', label: 'Hot', type: 'switch', width: 2 },
        ],
      }),
    [],
  );
  return <CrudPage schema={schema} />;
}
